<template>
    <div>
        <el-row class="bottom20">
            <el-table :data="page.records" :row-class-name="getVisitedRowClassName" :cell-class-name="getSelectedCellClassName">
                <el-table-column prop="customerName" width="200">
                    <template slot="header" slot-scope="scope">
                        客户名称<br>
                        <!--<el-input size="mini" v-model="pageSearch.search.like_customerName" placeholder="客户名称"></el-input>-->
                        <customer-select v-model="pageSearch.search.customerId"
                                         @change="pageSearch.search.contractId = null" :filterable="true" :clearable="true"
                                         size="mini">
                        </customer-select>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.customerName}}
                    </template>
                </el-table-column>
                <el-table-column prop="contractName" width="200">
                    <template slot="header" slot-scope="scope">
                        合同名称<br>
                        <!--<el-input size="mini" v-model="pageSearch.search.like_contractName" placeholder="合同名称"></el-input>-->
                        <contract-select v-model="pageSearch.search.contractId"
                                         :customer-id="pageSearch.search.customerId" :filterable="true" :clearable="true"
                                         size="mini">
                        </contract-select>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.contractName}}
                    </template>
                </el-table-column>
                <el-table-column prop="contractItemName" width="200">
                    <template slot="header" slot-scope="scope">
                        计费项<br>
                        <el-input size="mini" v-model="pageSearch.search.like_contractItemName" placeholder="计费项"></el-input>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.contractItemName}}
                    </template>
                </el-table-column>
                <el-table-column prop="month" v-for="monthColumn in monthInfo.monthColumns" :key="monthColumn.month">
                    <template slot="header" slot-scope="scope">
                        {{monthColumn.title}}<br>
                    </template>
                    <template slot-scope="scope">
                        <div>
                            <div v-if="!contractItemRecordLoading && monthColumn.month <= currentMonth &&
                                isDateValid(monthColumn.month, scope.row)">
                                <a v-if="addBtnExisted && getContractItemRecord(scope.row.contractItemId, monthColumn.month) == null"
                                    @click="toDetailAddTab(scope.row, monthColumn.month)" style="cursor: pointer;">
                                    新增
                                </a>
                                <a v-if="editBtnExisted && getContractItemRecord(scope.row.contractItemId, monthColumn.month) != null"
                                   @click="toDetailEditTab(scope.row, monthColumn.month)" style="cursor: pointer;">
                                    修改
                                </a>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>

        <el-row type="flex" class="row-bg" justify="end">
            <el-pagination
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :current-page="pageSearch.current"
                    :page-sizes="[10, 25, 50, 100]"
                    :page-size="pageSearch.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="page.total">
            </el-pagination>
        </el-row>
    </div>
</template>

<script>
    import _ from 'lodash'
    import Emitter from 'element-ui/src/mixins/emitter'
    import {formatDate, parseDate} from 'element-ui/src/utils/date-util'
    import {merge} from "@/util/common"
    import BillingServer from '@/api/billing'

    import CustomerSelect from '@/views/billing/customer/component/customer.select'
    import ContractSelect from '@/views/billing/contract/component/contract.select'

    import {
        COMPONENT_MAIN, COMPONENT_LIST,
        FN_TO_DETAIL_ADD, FN_TO_DETAIL_EDIT,
        PERMISSION_ADD, PERMISSION_EDIT, getContentByQuery
    } from "./contract.item.record.common";
    import {contractCanAddBillByContractId, contractCanEditBillByContractId} from "../../contract.common";

    export default {
        name: COMPONENT_LIST,
        componentName: COMPONENT_LIST,
        mixins: [Emitter],
        props: ['search'],
        components: {CustomerSelect, ContractSelect},
        data() {
            let content = getContentByQuery(this.$route.query);
            return {
                key: 'contractItemId',
                currentRowData: null,
                visited: [],
                currentMonth: formatDate(new Date(), 'yyyyMM'),
                monthInfo: {
                    beginMonth: null,
                    endMonth: null,
                    monthColumns: [],
                },
                pageSearch: {
                  current: 1,
                  size: 10,
                  search: {
                      contractItemContent: content,
                      like_customerName: null,
                      like_contractName: null,
                      like_contractItemName: null,
                      customerId: null,
                      contractId: null,
                      year: new Date().getFullYear() + '',
                  },
                },
                page: {
                  total: 0,
                  records: []
                },
                contractItemRecordLoading: false,
                contractItemRecords: [],
            };
        },
        watch: {
            'search': {
              deep: true,
              handler(value) {
                  if (value != null) {
                      this.pageSearch.search = merge(true, {}, this.pageSearch.search, value);
                  }
              },
            },
            'pageSearch.current': {
                deep: false,
                handler() {
                    this.queryByPage();
                },
            },
            'pageSearch.size': {
                deep: false,
                handler() {
                    this.reQueryByPage();
                },
            },
            'page': {
                deep: true,
                handler() {
                },
            },
            'pageSearch.search': {
                deep: true,
                handler() {
                    this.reQueryByPage();
                    /*if (value != null) {
                        this.dispatch(COMPONENT_MAIN, FN_LIST_QUERY);
                    }*/
                }
            }
        },
        computed: {
            addBtnExisted() {
                return (PERMISSION_ADD == null || this.hasPermission(PERMISSION_ADD));
            },
            editBtnExisted() {
                return (PERMISSION_EDIT == null || this.hasPermission(PERMISSION_EDIT));
            },
        },
        methods: {
            isDateValid(month, row) {
                let beginMonth = row.contractItemBeginDate == null ? null :
                    formatDate(parseDate(row.contractItemBeginDate, 'yyyy-MM-dd'), 'yyyyMM');
                let endMonth = row.contractItemEndDate == null ? null :
                    formatDate(parseDate(row.contractItemEndDate, 'yyyy-MM-dd'), 'yyyyMM');
                return (beginMonth == null || month >= beginMonth) && (endMonth == null || month <= endMonth);
            },
            async loadMonthInfo() {
                let year = this.pageSearch.search.year;
                if (year == null || String(year).trim() === '') {
                    this.$message.error('请选择年份');
                    return false;
                }
                let beginMonth = `${year}01`;
                let endMonth = `${year}12`;
                let monthColumns = [];
                for (let i = 1; i <= 12; i++) {
                    monthColumns.push({
                       month: i < 10 ? `${year}0${i}` : `${year}${i}`,
                       title: `${i}月`
                    });
                }
                this.monthInfo.beginMonth = beginMonth;
                this.monthInfo.endMonth = endMonth;
                this.monthInfo.monthColumns = monthColumns;
                return true;
            },
            async loadContractItemRecords() {
                let contractItemRecords = [];
                let records = this.page.records;
                if (records.length > 0) {
                    let beginMonth = this.monthInfo.beginMonth;
                    let endMonth = this.monthInfo.endMonth;
                    let contractItemIds = records.map(e => e.contractItemId);
                    let res = await BillingServer.contractItemRecord.getByMonth(beginMonth, endMonth, contractItemIds);
                    if (String(res.data.code) === '200' || res.data.success) {
                        contractItemRecords = res.data.data;
                    }
                }
                this.contractItemRecords = contractItemRecords;
            },
            getContractItemRecord(itemId, month) {
                let contractItemRecord = null;
                let contractItemRecords = this.contractItemRecords;
                for (let i = 0, len = contractItemRecords.length; i < len; i++) {
                    if (String(contractItemRecords[i].itemId) === String(itemId) && String(contractItemRecords[i].month) === String(month)) {
                        contractItemRecord = contractItemRecords[i];
                        break;
                    }
                }
                return contractItemRecord;
            },
            handleCurrentChange(current) {
                this.pageSearch.current = current;
            },
            handleSizeChange(size) {
                this.pageSearch.size = size;
            },
            async doQueryByPage() {
                let re = await this.loadMonthInfo();
                if (!re) {
                    return;
                }
                let res = await BillingServer.contractItemRecord.page(this.pageSearch);
                if (String(res.data.code) === '200' || res.data.success) {
                    let records = res.data.data.records;
                    this.page = {
                        total: res.data.data.total,
                        records: records,
                    };
                    this.contractItemRecordLoading = true;
                    await this.loadContractItemRecords();
                    this.contractItemRecordLoading = false;
                }
            },
            queryByPage: _.debounce(function() {
                this.doQueryByPage();
            }, 200) ,
            reQueryByPage() {
                if (this.pageSearch.current === 1) {
                    this.queryByPage();
                } else {
                    this.pageSearch.current = 1;
                }
            },
            query() {
                this.queryByPage();
            },
            reQuery() {
                this.reQueryByPage();
            },
            select(data) {
                this.currentRowData = data;
            },
            getSelectedCellClassName({row}) {
                let cellClassName = '';
                if (this.currentRowData && this.currentRowData[this.key] === row[this.key]) {
                    cellClassName += ' currentAccess ';
                }
                return cellClassName;
            },
            visit(data) {
                let id = data[this.key];
                if (this.visited.indexOf(id) === -1) {
                    this.visited.push(id);
                }
            },
            getVisitedRowClassName({row}) {
                let rowClassName = '';
                if (this.visited.indexOf(row[this.key]) !== -1) {
                    rowClassName += ' visited';
                }
                return rowClassName;
            },
            async toDetailAddTab(row, month) {
                let can = await contractCanAddBillByContractId(row.contractId);
                if (!can) {
                  this.$message.error('该合同还没有通过审批，不能新增！');
                  return;
                }
                let data = this.getData(row, month);
                this.dispatch(COMPONENT_MAIN, FN_TO_DETAIL_ADD, data);
            },
          async toDetailEditTab(row, month) {
                let can = await contractCanEditBillByContractId(row.contractId);
                if (!can) {
                  this.$message.error('该合同还没有通过审批，不能修改！');
                  return;
                }
                let data = this.getData(row, month);
                // this.select(data);
                // this.visit(data);
                this.dispatch(COMPONENT_MAIN, FN_TO_DETAIL_EDIT, data);
            },
            getData(row, month) {
                let contractItemRecord = this.getContractItemRecord(row.contractItemId, month);
                let data = {
                    id: contractItemRecord == null ? null : contractItemRecord.id,
                    itemId: row.contractItemId,
                    month: month,
                    content: this.pageSearch.search.contractItemContent
                };
                return data;
            },
        }
    }
</script>

<style scoped>

</style>